import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <VoxelGI> lights nothing yet, so the intent is `pending` and the badge reads "not implemented". The
 * Node3D base still mounts for `visible` and the workspace split, with Godot's editor gizmo on it
 * while the node is selected (`voxel_gi_gizmo_plugin.cpp:99`).
 */
import { useMemo } from 'react';
import { centredAabb } from '../../../godot/math/aabb';
import { NodeAabb } from '../../../r3f/components/NodeAabb';
import { PluginGizmo } from '../../../r3f/gizmo/PluginGizmo';
import { invisibleBase } from '../../../r3f/invisibleBase';
import { Node3D } from '../../base/node3d/Component';
import { VoxelGIGizmo } from './Gizmo';
function UndrawnVoxelGI({ node, children }) {
    const voxelGi = node.properties;
    const aabb = useMemo(() => centredAabb(voxelGi.size), [voxelGi.size]);
    return (_jsxs(Node3D, { node: node, children: [_jsx(NodeAabb, { aabb: aabb }), _jsx(PluginGizmo, { drawnFor: "selected-only", children: _jsx(VoxelGIGizmo, { voxelGi: voxelGi }) }), children] }));
}
export const VoxelGI = invisibleBase(UndrawnVoxelGI);
//# sourceMappingURL=Component.js.map